import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { EditionKind } from "../types";
import { buildEditionPayload, EditionPayloadForm } from "../editionPayload";

export const useEditionSubmit = (
  corporateId: string | number,
  kind: EditionKind,
  editionId?: string | number,
) => {
  const isEdit = editionId != null && String(editionId) !== "";

  const url = isEdit
    ? `${ServicesURL.getEditions}/${kind}/${editionId}?corporateId=${corporateId}`
    : `${ServicesURL.getEditions}/${kind}?corporateId=${corporateId}`;

  const { trigger, isMutating } = useSWRMutation(
    url,
    (u: string, { arg }: { arg: any }) =>
      fetcher<any>(u, isEdit ? MethodType.PUT : MethodType.POST, arg),
  );

  const submitEdition = (form: EditionPayloadForm, sessions: any[]) =>
    trigger(buildEditionPayload(form, sessions, kind));

  return { submitEdition, isSubmitting: isMutating, isEdit };
};
